import {
  Card,
  CardContent,
  CardMedia,
} from '@mui/material';
import MediaPlayer from '../../../media/MediaPlayer';
import TextLines from '../../../text/TextLines';
import './SequencingPrompt.scss';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  sequenceCard: {},
  sequenceCardId: '',
};

export default function SequencingPrompt(p) {
  const { sequenceCard, sequenceCardId } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <Card
      className='sequencing-prompt'
      id={sequenceCardId}
      key={sequenceCardId}
    >
      <Card className='prompt-content'>
        {
          sequenceCard.image ? (
            <CardMedia
              className='sequencing-component-image'
              image={sequenceCard.image}
              title='Sequencing'
            />
          ) : null
        }
        {sequenceCard.text
          ? (
            <CardContent className={`sequencing-component-text ${sequenceCard.image ? 'text-with-image' : ''}`}>
              <TextLines textLines={sequenceCard.text} />
            </CardContent>
          ) : null}
      </Card>
      <MediaPlayer
        audioUrl={sequenceCard.audio}
        videoUrl={sequenceCard.video}
        parentElementId={sequenceCardId}
        className='sequence-media'
      />
    </Card>
  );
}
